const colors = {
  $light: '#FFFFFF',

  $greyscale_dark_grey: '#828282',
  $greyscale_dark_grey_1: '#595959',
  $greyscale_dark_grey_2: '#686A6C',
  $greyscale_dark_grey_3: '#777777',
  $greyscale_dark_grey_4: '#757575',
  $greyscale_dark_grey_5: '#808080',
  $greyscale_dark_grey_6: '#838383',
  $greyscale_dark_grey_7: '#838485',
  $greyscale_dark_grey_8: '#999999',
  $greyscale_light_grey_9: '#6A6A6A',
  $greyscale_dark_grey_10: '#6D787D',

  $greyscale_medium_grey: '#BDBDBD',
  $greyscale_medium_grey_1: '#B1B1B2',
  $greyscale_medium_grey_2: '#BEBEBE',
  $greyscale_medium_grey_3: '#CCCCCC',
  $greyscale_medium_grey_4: '#D6D6D6',

  $greyscale_light_grey: '#E0E0E0',
  $greyscale_light_grey_1: '#D9D9D9',
  $greyscale_light_grey_2: '#E3E3E3',
  $greyscale_light_grey_3: '#E8E8E8',
  $greyscale_light_grey_4: '#EFEFEF',

  $background_grey: '#F2F2F2',
  $background_grey_1: '#E8EAEC',
  $background_grey_2: '#F0F0F0',
  $background_grey_3: '#F3F3F4',
  $background_grey_4: '#FAFAFA',
  $background_grey_5: '#D3DADD',
  $background_grey_6: '#A7ADB4',

  $greyscale_black: '#3E3E3E',
  $greyscale_black_1: '#262626',
  $greyscale_black_2: '#041527',
  $greyscale_black_3: '#090F36',
  $greyscale_black_4: '#475461',
  $greyscale_black_5: '#2D3A40',

  $auxiliary_light_sky: '#56CCF2',
  $auxiliary_light_sky_1: '#D9E9ED',
  $auxiliary_light_sky_2: '#D9E8FD',
  $auxiliary_light_sky_3: '#A6D5E7',
  $auxiliary_light_sky_4: '#75BFDB',
  $auxiliary_light_sky_5: '#88C6B3',
  $auxiliary_light_sky_6: '#5EC3C6',
  $auxiliary_light_sky_7: '#54A6C7',

  $auxiliary_sky: '#1271EE',
  $auxiliary_sky_1: '#2D76F6',
  $auxiliary_sky_2: '#4190F7',
  $auxiliary_sky_3: '#4579B2',
  $auxiliary_sky_4: '#86A9CD',
  $auxiliary_sky_5: '#337AB7',
  $auxiliary_sky_6: '#E6F7FF',
  $auxiliary_sky_7: '#1890FF',

  $brandcolor_primary_dark_green: '#24A95D',
  $brandcolor_primary_dark_green_1: '#038374',
  $brandcolor_primary_dark_green_2: '#08A027',
  $brandcolor_primary_dark_green_3: '#137F29',
  $brandcolor_primary_dark_green_4: '#61BF5B',
  $brandcolor_primary_dark_green_5: '#55B249',
  $brandcolor_primary_dark_green_6: '#74AA49',
  $brandcolor_primary_dark_green_6_opacity: '#74aa495c',
  $brandcolor_primary_dark_green_7: '#A3C687',
  $brandcolor_primary_dark_green_8: '#EBFEDA',
  $brandcolor_primary_dark_green_9: '#69E154',
  $brandcolor_primary_dark_green_10: '#00FF03',
  $brandcolor_primary_dark_green_11: '#24A95D',
  $brandcolor_primary_dark_green_12: '#EEFFF6',

  $background_light_yolk: '#FFF8D2',
  $background_light_yolk_1: '#FFFEA6',

  $auxiliary_dark_yolk: '#E47515',
  $auxiliary_dark_yolk_1: '#EEAE67',

  $auxiliary_yolk: '#FFCA29',
  $auxiliary_yolk_1: '#F0AF41',
  $auxiliary_yolk_2: '#F0AD4E',
  $auxiliary_yolk_3: '#AD6800',
  $auxiliary_yolk_4: '#FFFBE6',
  $auxiliary_yolk_5: '#FAAD14',

  $calendula_gold_1: '#FFFBE6',
  $calendula_gold_3: '#FFE58F',

  $auxiliary_berry: '#D42929',
  $auxiliary_berry_1: '#DC6069',
  $auxiliary_berry_2: '#ED5B56',
  $auxiliary_berry_3: '#EE5F5A',
  $auxiliary_berry_4: '#E23C39',
  $auxiliary_berry_5: '#C73A39',
  $auxiliary_berry_6: '#C95C54',
  $auxiliary_berry_7: '#DC948F',
  $auxiliary_berry_8: '#E0B2B8',
  $auxiliary_berry_9: '#EECEC9',
  $auxiliary_berry_10: '#C64027',
  $auxiliary_berry_11: '#97301D',
  $auxiliary_berry_12: '#CF1322',
  $auxiliary_berry_13: '#FFF1F0',
  $auxiliary_berry_14: '#D85450',

  $brandcolor_primary_blue: '#0D3549',
  $brandcolor_primary_blue_1: '#0D3549',

  $brandcolor_primary_green: '#ADE84F',
  $brandcolor_primary_green_1: '#ADE84F',

  tmov_green: '#24A95D',
  light_green: '#66cb91',
  green: '#55B349',
  white: '#FFFFFF',
  blue: '#467BB2',
  gray: '#676A6C',
  gray_2: '#6A6A6A',
  third: '#728591',
  dark_blue: '#001529',
};

export default colors;
